import { buildConsentI18nContentZip } from './consent_template_i18n_zip';
function safeZipBaseName(name) {
    const trimmed = name
        .trim()
        .replace(/[<>:"/\\|?*]+/g, '_')
        .replace(/\s+/g, '_');
    return trimmed.slice(0, 80) || 'consent_template';
}
/**
 * Axon-style HTML bundle (`i18n.*.content.zip`): `index.html`, `bundle.js`, `hooks.js`, `assets/<pdf>`.
 * Assembled by executing the compiled template graph (see {@link buildConsentI18nContentZip}).
 */
export async function buildConsentCompiledTemplateZip(bundle) {
    return buildConsentI18nContentZip(bundle);
}
/** Triggers a browser download of the compiled template package as a ZIP file. */
export async function downloadConsentCompiledTemplateZip(displayName, bundle) {
    const blob = await buildConsentCompiledTemplateZip(bundle);
    const base = safeZipBaseName(displayName);
    const filename = `${base}_consent_content.zip`;
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.rel = 'noopener';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
}
